import OneliveFooterContent from './OneliveFooterContent';

interface Props {
  id?: string;
  className?: string;
}

/** PC 하단 푸터 — 모바일 드로어와 동일한 사이트정보 API 사용 */
export default function OneliveSiteFooter({ id, className }: Props) {
  return (
    <footer
      id={id}
      className={['onelive-site-footer', className].filter(Boolean).join(' ')}
    >
      <div className="onelive-site-footer-inner">
        <OneliveFooterContent variant="site" />
      </div>
    </footer>
  );
}
